  <app-incident-search
  [searchTerm]="searchTerm()"
  [dateRange]="dateRange()"
  (searchTermChange)="onSearchTermChange($event)"
  (dateRangeChange)="onDateRangeChange($event)"
  (clearFilters)="onClearFilters()">
</app-incident-search>

<div style="margin-bottom: 16px;">
  <nz-card nzTitle="Breakdowns by Status" nzSize="small">
    <div style="display: flex; flex-wrap: wrap; justify-content: space-around;">
      @for (item of statusCounts(); track item.status) {
        <div style="border: 1px solid #d9d9d9; padding: 12px 10px; text-align: center; min-width: 120px;">
          <nz-statistic
            [nzValue]="item.count"
            [nzTitle]="item.status"
            [nzValueStyle]="{ color: '#3f8600' }">
          </nz-statistic>
        </div>
      }
    </div>
  </nz-card>
</div>

<nz-table #incidentsTable [nzData]="filteredIncidents()" nzTableLayout="fixed" nzSize="small" [nzLoading]="isLoading()" [nzScroll]="{ y: '60vh' }">
  <thead>
    <tr>
      @for (col of columns(); track col.key) {
      <th [nzWidth]="col.width || 'auto'">{{ col.title }}</th>
      }
    </tr>
  </thead>
  <tbody>
    @for (data of incidentsTable.data; track data.incidentId) {
      <tr [ngClass]="{ 'tech-late': isTechLate(data) }">
        @for (col of columns(); track col.key) {
        <td [style.background-color]="getActionColumnBackground(col.key, data)">
          @switch (col.key) {
          @case ('incidentNo') {
              <small>{{ data.clientName }}</small><br />
              <a (click)="onClickViewIncident(data)" style="text-align: left;" nz-row>
                <strong>#{{ data.incidentNumber }}</strong>
                @if (data.orderNumber) {
                    / <span style="font-weight: bold;">{{data.orderNumber}}</span><br />
                }
              </a>
          }
          @case ('dt') {
            <small>{{ data.dtLogged + 'Z' | date:'MMM d, y h:mm a' }}</small><br />
            <span nz-tooltip [nzTooltipTitle]="data.location.description">
              <small>{{ data.location.descriptionShort }}</small>
            </span>
          }
          <!-- @case ('fleet') {
          <small>{{ data.clientName }}</small>
          } -->
          @case ('vehicleAndDriver') {
          <div style="font-weight: bold;">{{ data.fleetVehicle.registrationNumber }}</div>
          <div>{{ data.driver.name }}</div>
          <small style="color: #8c8c8c;">{{ data.driver.phoneNumber }}</small>
          }
          @case ('status') {
          <small>{{data.status}}</small>
          <nz-progress [nzPercent]="getIncidentStatusPercentage(data.statusId).toFixed(0)"
            [nzStrokeColor]="{ '0%': '#108ee9', '100%': '#87d068' }" [nzShowInfo]="false" nzStatus="active"></nz-progress>
          }
          @case ('eta') {
          @if (data.breakdownTechnicianDriverEta) {
          <div nz-col nzSpan="24" style="text-align: center;">
            <small><strong>{{ data.breakdownTechnicianDriverEta + 'Z' | date:'HH:mm' }}</strong></small>
            <br>
            @if (data.statusId < 8) {
              <small style="color: #8c8c8c;" >{{ gFuncs.formatMinutesToDuration(gFuncs.calculateMinutes(data.breakdownTechnicianDriverEta)) }}  </small><br>
              @if (etaChanges().has(data.incidentId)) {
                <nz-tag [nzColor]="etaChanges().get(data.incidentId)! > 0 ? 'orange' : 'green'" style="margin-top: 4px;">
                  {{ etaChanges().get(data.incidentId)! > 0 ? '+' : '' }}{{ etaChanges().get(data.incidentId) }} mins
                </nz-tag>
              }
              @if (data.breakdownTechnician && data.statusId == 7) {
                <button nz-button nzType="primary" nzSize="small" (click)="openTrackDriverModal(data)" nz-tooltip="Track Technician"><nz-icon nzType="environment"></nz-icon></button>
              }           
            }
          </div>
          } @else {
          <small style="color: #8c8c8c;">{{ data.statusId >= 7 ? 'N/A' : 'Not Assigned' }}</small>
          }
          }
          @case ('serviceProvider') {
          <div style="font-weight: bold;"><small>{{ getServiceProviderName(data) }}</small></div>
          <div><small>{{ data.serviceProviderDriverName }}</small></div>
          }
          @case ('callCentre') {
          <small>{{ data.callcentreName }}</small>
          }

          <!-- @case ('location') {
          <span nz-tooltip [nzTooltipTitle]="data.location.description">
            <small>{{ data.location.descriptionShort }}</small>
          </span>
          } -->
          @case ('receivedInvoice') {
          <button nz-button nzType="primary" nz-tooltip="Navigate to Invoice" (click)="viewDoc(data, 5)"><nz-icon
              nzType="inbox"></nz-icon></button>
          }
          @case ('sentInvoice') {
          <button nz-button nzType="primary" nz-tooltip="Navigate to Invoice" (click)="viewDoc(data, 4)"><nz-icon
              nzType="send"></nz-icon></button>
          }
          @case ('latestQuote') {
          <button nz-button nzType="primary" nz-tooltip="Navigate to Quote" (click)="viewDoc(data, 2)"><nz-icon
              nzType="file-text" nzTheme="outline"></nz-icon></button>
          }
          @case('timeElapsed'){
          <small>{{ gFuncs.formatMinutesToDuration(calculateTimeElapsed(data.dtLogged)) }}</small>
          }
          @case('pow') {
            <div nz-col class="cell-container">
              <div nz-row>
                @if (data.statusId >= 5 && data.statusId <= 15) {
                  <button nz-button nzType="primary" nz-tooltip="Upload Proof of Work" (click)="onClickUploadPoW(data.incidentId)"><nz-icon
                      nzType="upload"></nz-icon></button>
                }
                @if (data.statusId > 10) {
                  <small style="color: #8c8c8c; margin-left: 8px;"><button nz-button nzType="primary" nz-tooltip="Download Proof of Work Report" (click)="onClickProofOfWork(data.incidentId)" [nzLoading]="isLoadingProofOfWork"><nz-icon
                      nzType="download"></nz-icon></button></small>
                }
                @else {
                  &nbsp;
                }
              </div>
              <br/><small style="color: #8c8c8c; margin-left: 8px;">{{ dtWorkReportAssigned(data) | date:'MMM d, y h:mm a' }}</small>
            </div>
          }
          @case('spinvoice') {
            <div nz-col class="cell-container">
              @if (data.statusId >= 12 && hasSPInvoice(data)) {
                <button nz-button nzType="primary" nz-tooltip="Download Service Provider Invoice" (click)="onClickViewSPInvoice(data.incidentId)" nzSize="small" >
                  <nz-icon nzType="eye"></nz-icon> View</button>
              } @else if (data.statusId >= 11 && !hasSPInvoice(data)) {
                <button nz-button nzType="primary" nz-tooltip="Upload Service Provider Invoice" (click)="onClickUploadSPInvoice(data.incidentId)" nzSize="small" >
                  <nz-icon nzType="upload"></nz-icon> Upload</button>
              }
              @else {
                &nbsp;
              }
              <br/><small style="color: #8c8c8c; margin-left: 8px;">{{ dtSPInvoiceUploaded(data) | date:'MMM d, y h:mm a' }}</small>
            </div>
          }
          @case('updatepo') {
            <div nz-col class="cell-container">
              @if (data.statusId === 12) {
                <button nz-button nzType="primary" nz-tooltip="Go to Service Provider Quote" (click)="onClickGoToServiceProviderQuote(data.incidentId)" nzSize="small" >
                  <nz-icon nzType="shopping-cart"></nz-icon> Update</button>
              }
              @else if (data.statusId > 12) {
                <b><small>R{{getServiceProviderQuoteTotal(data.incidentId) }} ex vat</small></b>
              }
              @else {
                &nbsp;
              }
              <br/><small style="color: #8c8c8c; margin-left: 8px;">{{ dtPOUpdated(data) | date:'MMM d, y h:mm a' }}</small>
            </div>
          }
          @case('reinvoice') {
            <div nz-col class="cell-container">
              @if (data.statusId === 15) {   
                <button nz-button nzType="primary" nz-tooltip="Re-invoice Customer" (click)="onClickReInvoiceCustomer(data.incidentId)" nzSize="small" >
                  <nz-icon nzType="redo"></nz-icon> Re-invoice</button>
              }
              @else if (data.statusId > 15) {
                <b><small>R{{getFleetQuoteTotal(data.incidentId) }} ex vat</small></b>
                <button nz-button nzType="primary" nz-tooltip="View Fleet Invoice" (click)="onClickReInvoiceCustomer(data.incidentId)" nzSize="small" >
                  <nz-icon nzType="eye"></nz-icon> View</button>
              }
              @else {
                &nbsp;
              }
              <br/><small style="color: #8c8c8c; margin-left: 8px;">{{ dtReInvoiced(data) | date:'MMM d, y h:mm a' }}</small>
            </div>
          }
          @case ('invoice') {
            <div nz-col class="cell-container">
              @if (data.statusId >= 16 && hasFleetInvoice(data)) {
                <button nz-button nzType="primary" nz-tooltip="Download Fleet Invoice" (click)="onClickViewFleetInvoice(data.incidentId)" nzSize="small" >
                  <nz-icon nzType="eye"></nz-icon> View</button>
              } @else if (data.statusId >= 16 && !hasFleetInvoice(data)) {
                <button nz-button nzType="primary" nz-tooltip="Upload Fleet Invoice" (click)="onClickUploadFleetInvoice(data.incidentId)" nzSize="small" >
                  <nz-icon nzType="upload"></nz-icon> Upload</button>
              }
              @else {
                &nbsp;
              }
              <br/><small style="color: #8c8c8c; margin-left: 8px;">{{ dtInvoiceUploaded(data) | date:'MMM d, y h:mm a' }}</small>
            </div>
          }
          @case ('actions') {
          <div nz-col class="cell-container">
              <nz-space nzSize="small" nzDirection="vertical">
              <button *nzSpaceItem nz-button nzType="primary" nzSize="small" (click)="onClickViewIncident(data)">
                <span nz-icon nzType="eye"></span>
                View
              </button>
              <!-- <button *nzSpaceItem nz-button nzSize="small" (click)="onClickNavigate(data)">
                          <span nz-icon nzType="compass"></span>
                          Navigate
                        </button>
                        <button *nzSpaceItem nz-button nzSize="small" (click)="onClickProofOfWork(data.incidentId)">
                          <span nz-icon nzType="file-pdf"></span>
                          PoW
                        </button> -->
              @if (data.statusId >= 16 && authService.isClientCallCentre && !data.incidentActions?.dtClosed) {
                <button *nzSpaceItem nz-button nzType="primary" nzSize="small" (click)="onClickCompleteIncident(data.incidentId)">
                  <nz-icon nzType="check-circle" nzTheme="outline" />
                  Complete
                </button>
              }
            </nz-space>
              @if (data.statusId > 16) {
                  <br/><small style="color: #8c8c8c; margin-left: 8px;">{{ dtClosed(data) | date:'MMM d, y h:mm a' }}</small>
                }
          </div>

          }
        }
        </td>
      }
    </tr>
  }
  </tbody>
</nz-table>

<nz-modal [(nzVisible)]="isUploadModalVisible" nzTitle="Upload File" (nzOnCancel)="isUploadModalVisible = false"
  (nzOnOk)="isUploadModalVisible = false">
  <ng-container *nzModalContent>
    <app-file-uploader [incidentId]="selectedIncidentId()" [documentClassification]="selectedUploadDocumentClassificationId()"
      (uploadedDocuments)="onUploadComplete($event)"></app-file-uploader>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="isTrackTechModalVisible" nzTitle="Track Driver" (nzOnCancel)="isTrackTechModalVisible = false"
  (nzOnOk)="isTrackTechModalVisible = false" [nzWidth]="850" >
  <ng-container *nzModalContent>
    <app-map-track-sp-tech [incident]="trackTechForIncident()"></app-map-track-sp-tech>
  </ng-container>
<app-incident-close-modal 
    [(visible)]="isCloseIncidentModalVisible" 
    [incidentId]="selectedIncidentIdToClose"
    (incidentClosed)="onIncidentClosed()">
</app-incident-close-modal>

